import React, { Component } from 'react'
import { Form, Icon, Input, Button, Row, Col, Spin, Select, message } from 'antd';
import {CardElement,injectStripe} from  "react-stripe-elements";
import Axios from 'axios';
import ReactGA from 'react-ga';
import {domainURL,CLOUD_FUNCTION} from "../../../../../config/fbConfig"
import moment from "moment"
import Approved from '../../components/stripe/approved';
import {connect} from "react-redux"
const FormItem = Form.Item;

class BillingStripe extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fullName:"",
      email:"",
      billingAddr:"",
      isLoading:false,
      confirmStatus:false,
      success:"",
      error:"",
      zip:"",
      city:"",
      country:"",
      charge:{},

    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  componentWillMount() {
    Axios.get("https://ipapi.co/json").then((res)=>{
         this.setState({country:res.data.country_name})
      })
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onChange=(e)=>{
    this.setState({[e.elementType]: e.complete})
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        var {card,fullName,billingAddr,zip,city,country} = this.state;
        var {email} = this.props.profile
        if(!card ) return message.error("Card not valid")
        this.setState({isLoading:true,success:"",error:"",charge:""})
        this.props.stripe.createToken({name:fullName,
          address_line1:billingAddr,address_city:city,address_country:country,address_zip:zip}).then(({token}) => {
         Axios.post(`${CLOUD_FUNCTION}/api/charge`,{token, charge: {
          amount:this.props.plan.price *100,
          currency:"usd",zip,city,country,
          email, name:fullName,billingAddr,
          plan:this.props.plan.title,
          description: ` 
          ${this.props.plan.title} Membership Plan
          ${this.props.plan.users} Users Included
          Email Support
          Help Center Access
            `
          }}).then((res)=>{
            console.log(res.data)
              if(res.data.message){
                  var current_period_end = this.props.plan.title ==="basic"? moment().add('1','M').unix(): moment().add('12','M').unix()
                  var signUpFlowToken =
                  {
                    subscription: {
                      customerId:res.data.customerId,
                      subscriptionId:res.data.subscriptionId
                    },
                    plan: this.props.plan.title,
                    email,
                    card:token.card,
                    current_period_end,
                    status: {
                      completed: true
                    }
                  }
                  this.props.signUpFlow(this.props.profile.uid, signUpFlowToken)
                  window.fbq('track', 'AddPaymentInfo');
                  ReactGA.event({
                    category: 'User',
                    action: 'Add Card Info',
                    label: 'User Interaction'
                  });
                  const {tap} = window
                  tap('conversion',this.props.profile.uid,this.props.plan.price,{},this.props.plan.title);
                  
                  this.setState({ isLoading:false,success:true})
              }else{
                  message.error(res.data.error)
                  this.setState({error:res.data.error,isLoading:false,})
              }
          }).catch((err)=>{
              console.log(err)
          message.error(err.error)
          this.setState({error:"An error has occured. Please try again later",isLoading:false})
          })

        }).catch((err)=>{
          message.error(err.error)
          this.setState({error:"An error has occured. Please try again later",isLoading:false})
      })
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {isLoading, success} = this.state        
    var {plan} = this.props;
    // console.log(this.props)
    return (
      <div className="billingcard">
      {success&&<Approved 
        price={plan.price}
        plan={plan.title} 
        paymentTokenID={this.props.paymentTokenID}
        history={this.props.history}/>}
        <Spin tip="Validating payment..." spinning={isLoading}>
        <Form onSubmit={(e) => {
            this.handleSubmit(e);
          }}>
          <Form.Item>
            {getFieldDecorator('fullName', {
                rules: [{ required: true, message: 'Please input your card name!' }],
            })(
                <Input 
                onChange={e => this.handleChange(e)}
                name = "fullName"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Card holder name" />
            )}
          </Form.Item>
         
          <Row>
              <Col span={12}>
              <Form.Item>
                  {getFieldDecorator('billingAddr', {
                      rules: [{ required: true, message: 'Please input your billing address!' }],
                  })(
                    <Input 
                    onChange={e => this.handleChange(e)}
                    name = "billingAddr"
                    prefix={<Icon type="home" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder="Billing address" />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
              <Form.Item>
                  {getFieldDecorator('city', {
                      rules: [{ required: true, message: 'Please input your billing address!' }],
                  })(
                    <Input 
                    onChange={e => this.handleChange(e)}
                    name = "city"
                    prefix={<Icon type="home" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder="City" />
                  )}
                </Form.Item>
              </Col>
          </Row>
          <Row>
              <Col span={12}>
              <Form.Item>
                  {getFieldDecorator('zip', {
                      rules: [{ required: true, message: 'Please input your billing address!' }],
                  })(
                    <Input 
                    onChange={e => this.handleChange(e)}
                    name = "zip"
                    prefix={<Icon type="home" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder="ZIP / Postal Code" />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
              <Form.Item>
                  {getFieldDecorator('country', {
                      initialValue:this.state.country,
                      rules: [{ required: true, message:'Country' }],
                  })(
                    <Input 
                    onChange={e => this.handleChange(e)}
                    name = "country"
                    disabled
                    defaultValue={this.state.country}
                    prefix={<Icon type="radar-chart" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder={this.state.country||"Country"} />
                  )}
                </Form.Item>
              </Col>
          </Row>
          <Form.Item>
            <CardElement onChange={this.onChange}/>
          </Form.Item>
          <FormItem>
            <Button  type="primary" htmlType="submit" className="xpad-btn">
                  Pay and Unlock All Content
              </Button>
              <span className="secure"><i className="fa fa-lock"></i> Secure Payment</span>
          </FormItem>
        </Form>
        </Spin>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile:state.firebase.profile,
});
const mapDispatchToProps = null;
// export default injectStripe(Billing);
const WrappedBillingStripe= Form.create()(BillingStripe);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectStripe(WrappedBillingStripe));
// export default injectStripe(WrappedBillingStripe)